import * as arion from './arion.js';

export default {
    arion,
};

if (window.EQLAPP === undefined) {
    window.EQLAPP = {};
}

// Global Access
if (window.EQLAPP) {

    // Admin
    window.EQLAPP.ARION = window.EQLAPP.ARION || {};
    Object.entries(arion).forEach(([key, value]) => {
        window.EQLAPP.ARION[key] = value;
    });

}